export const OPEN_CHANGE_PASSWORD = 'popupReducer/OPEN_CHANGE_PASSWORD';
export type OPEN_CHANGE_PASSWORD = typeof OPEN_CHANGE_PASSWORD;

export const CLOSE_CHANGE_PASSWORD = 'popupReducer/CLOSE_CHANGE_PASSWORD';
export type CLOSE_CHANGE_PASSWORD = typeof CLOSE_CHANGE_PASSWORD;

export const OPEN_DELETE_DIALOG = 'popupReducer/OPEN_DELETE_DIALOG';
export type OPEN_DELETE_DIALOG = typeof OPEN_DELETE_DIALOG;

export const CLOSE_DELETE_DIALOG = 'popupReducer/CLOSE_DELETE_DIALOG';
export type CLOSE_DELETE_DIALOG = typeof CLOSE_DELETE_DIALOG;


// WEBPACK FOOTER //
// ./src/modules/popup/constants.ts